import { classNames } from '../utilities';

export const Sort = ({ fill = '#000000', className, onClick }) => {
  return (
    <svg
      className={classNames('sort-icon', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      id="sort_icon"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="descend"
        d="M3.14565 2.3125C3.36472 2.3125 3.54517 2.47737 3.56991 2.68972L3.57277 2.73949L3.57235 12.3844L5.56077 10.3964L5.59795 10.3632C5.76568 10.2305 6.00977 10.2415 6.16461 10.3964C6.31861 10.5504 6.33048 10.7926 6.20021 10.96L6.16461 11.0003L3.14492 14.0202L0.125087 11.0003L0.0919127 10.963C-0.0297724 10.8095 -0.0306326 10.5914 0.0893389 10.4368L0.125087 10.3963L0.162263 10.3632C0.315979 10.2415 0.533886 10.2406 0.688472 10.3606L0.72894 10.3963L2.71825 12.3861L2.71853 2.73932C2.71853 2.5204 2.8834 2.33981 3.0959 2.31521L3.14565 2.3125Z"
        fill={fill}
      />
      <path
        className="ascend"
        d="M13.8543 3.01984L10.8344 0L7.8146 3.02006L7.77899 3.06038C7.64873 3.22782 7.6606 3.47004 7.8146 3.62404C7.96944 3.7789 8.21367 3.78991 8.38126 3.65722L8.41858 3.62404L10.4053 1.63631L10.4056 11.2808L10.4084 11.3306C10.4332 11.543 10.6136 11.7078 10.8327 11.7078L10.8825 11.705C11.095 11.6804 11.2598 11.4998 11.2598 11.2809L11.2594 1.63266L13.2503 3.62383L13.2907 3.65958C13.4453 3.77955 13.6634 3.77869 13.817 3.65701L13.8543 3.62383L13.89 3.58336C14.01 3.42878 14.0091 3.21073 13.8874 3.05716L13.8543 3.01984Z"
        fill={fill}
      />
    </svg>
  );
};
